import { render, staticRenderFns } from "./HUploading.vue?vue&type=template&id=70d83ad2&scoped=true&"
import script from "./HUploading.vue?vue&type=script&lang=js&"
export * from "./HUploading.vue?vue&type=script&lang=js&"
import style0 from "./HUploading.vue?vue&type=style&index=0&id=70d83ad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d83ad2",
  null
  
)

export default component.exports